// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * IMS Management API
 * Management API for the IMS catalog: partitions, isolation units, and clusters, returned in a Kubernetes-familiar metadata/spec/status envelope (ADR-0008).
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface ClusterSpec
 */
export interface ClusterSpec {
  /**
   *
   * @type {string}
   * @memberof ClusterSpec
   */
  cloudProvider?: string;
  /**
   *
   * @type {object}
   * @memberof ClusterSpec
   */
  _configuration?: object;
  /**
   *
   * @type {string}
   * @memberof ClusterSpec
   */
  isolationUnitId?: string;
  /**
   *
   * @type {string}
   * @memberof ClusterSpec
   */
  partitionId?: string;
  /**
   *
   * @type {string}
   * @memberof ClusterSpec
   */
  region?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ClusterSpec
   */
  roles?: Array<string>;
}

/**
 * Check if a given object implements the ClusterSpec interface.
 */
export function instanceOfClusterSpec(value: object): value is ClusterSpec {
  return true;
}

export function ClusterSpecFromJSON(json: any): ClusterSpec {
  return ClusterSpecFromJSONTyped(json, false);
}

export function ClusterSpecFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ClusterSpec {
  if (json == null) {
    return json;
  }
  return {
    cloudProvider:
      json['cloud_provider'] == null ? undefined : json['cloud_provider'],
    _configuration:
      json['configuration'] == null ? undefined : json['configuration'],
    isolationUnitId:
      json['isolation_unit_id'] == null ? undefined : json['isolation_unit_id'],
    partitionId:
      json['partition_id'] == null ? undefined : json['partition_id'],
    region: json['region'] == null ? undefined : json['region'],
    roles: json['roles'] == null ? undefined : json['roles'],
  };
}

export function ClusterSpecToJSON(json: any): ClusterSpec {
  return ClusterSpecToJSONTyped(json, false);
}

export function ClusterSpecToJSONTyped(
  value?: ClusterSpec | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    cloud_provider: value['cloudProvider'],
    configuration: value['_configuration'],
    isolation_unit_id: value['isolationUnitId'],
    partition_id: value['partitionId'],
    region: value['region'],
    roles: value['roles'],
  };
}
